import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { toast } from "sonner";
import { Fuel, Loader2 } from "lucide-react";
import { formatDetail } from "@/lib/api";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("adhe.surya.142@gmail.com");
  const [password, setPassword] = useState("admin123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState({ name: "SPBU Energy ERP", tagline: "Financial & Stock Management" });

  useEffect(() => {
    // public-ish: try to fetch company name (requires auth actually, so this may fail silently)
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/company/public`)
      .then(r => r.ok ? r.json() : null)
      .then(d => d && setCompany(d))
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Selamat datang, ${u.name}`);
      nav("/");
    } catch (e) {
      setErr(formatDetail(e.response?.data?.detail) || "Gagal login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      {/* Left visual */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 text-white overflow-hidden bg-[#0B0F17]">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E30613]/20 via-transparent to-[#005DAA]/20" />
        <div className="absolute -right-32 -top-32 w-96 h-96 rounded-full bg-[#E30613]/25 blur-3xl" />
        <div className="absolute -left-32 -bottom-32 w-96 h-96 rounded-full bg-[#005DAA]/30 blur-3xl" />
        <div className="relative">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-[#E30613] grid place-items-center shadow-2xl shadow-red-900/40">
              <Fuel className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="text-2xl font-extrabold tracking-tight">{company.name}</div>
              <div className="text-sm text-slate-400">{company.tagline}</div>
            </div>
          </div>
        </div>
        <div className="relative space-y-6">
          <h1 className="text-4xl xl:text-5xl font-extrabold leading-tight tracking-tight">
            Kelola SPBU Anda<br />
            <span className="text-[#E30613]">dengan presisi</span>
          </h1>
          <p className="text-slate-300 max-w-md leading-relaxed">
            Buku stock BBM, transaksi penjualan, pembelian, laporan keuangan, dan penyusutan aset sesuai PMK 72/2023 — semua dalam satu platform.
          </p>
          <div className="grid grid-cols-4 gap-3 max-w-md">
            {[
              ["Pertalite", "bg-emerald-500"],
              ["Dexlite", "bg-lime-500"],
              ["Pertamax", "bg-blue-500"],
              ["Turbo", "bg-rose-500"],
            ].map(([n, c]) => (
              <div key={n} className="rounded-lg bg-white/5 border border-white/10 p-3 text-center backdrop-blur">
                <div className={`w-2 h-2 rounded-full ${c} mx-auto mb-2`} />
                <div className="text-xs font-semibold text-slate-200">{n}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative text-xs text-slate-400">© 2026 SPBU Energy ERP</div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <Card className="w-full max-w-md border-slate-200 shadow-xl shadow-slate-200/60">
          <CardHeader>
            <CardTitle className="text-2xl font-extrabold tracking-tight">Masuk ke Dashboard</CardTitle>
            <CardDescription>Gunakan akun admin atau operator SPBU Anda.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="login-username-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="pw">Password</Label>
                <Input
                  id="pw"
                  type="password"
                  data-testid="login-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {err && <Alert variant="destructive"><AlertDescription>{err}</AlertDescription></Alert>}
              <Button
                type="submit"
                data-testid="login-submit-button"
                disabled={loading}
                className="w-full bg-[#E30613] hover:bg-[#C8040F] text-white font-semibold h-11"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Masuk"}
              </Button>
              <div className="rounded-lg bg-slate-50 border border-slate-200 p-3 text-xs text-slate-600 space-y-1">
                <div><strong>Admin:</strong> adhe.surya.142@gmail.com / admin123</div>
                <div><strong>Operator:</strong> operator@spbu.id / operator123</div>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
